import React, { useEffect, useState } from "react";
import {
  Page,
  Text,
  View,
  Document,
  Image as ReactPdfImage,
} from "@react-pdf/renderer";
import Dayjs from "dayjs";

// Custom.
import { TemplateProps } from "../global";
import { styles } from "./styles";
import { baseStyles } from "../styles";
import I18n from "@vocollege/app/dist/modules/Services/I18n";
import {
  getContactName,
  // getGroupLogotype,
} from "@vocollege/app/dist/modules/VoHelpers";
import { getStringPlaceHolder } from "services/Utils";
import { convertSvgToImage } from "@vocollege/app/dist/modules/VoHelpers";
import LogoSvg from "@vocollege/theme/dist/images/vocollege.svg";
// import { GeneralObject } from "@vocollege/app/dist/global";

const LanguageRepresentativeDiplomaTemplate: React.FC<TemplateProps> = (
  props
) => {
  const { item } = props;
  const [logotype, setLogotype] = useState<any>(null);

  // Methods.

  const setImages = async () => {
    // let output: GeneralObject[] = [];
    try {
      let logo = LogoSvg;
      // if (item.collegeObject) {
      //   getGroupLogotype(item.collegeObject, "logo3", output);
      //   if (output.length > 0) {
      //     logo = output[0].url;
      //   }
      // }
      let convertedImage = await convertSvgToImage(logo, 300);
      setLogotype(convertedImage);
    } catch (error) {
      console.error(error);
    }
  };

  const getDate = () => {
    return item ? Dayjs(item.date).format("D MMMM YYYY") : "";
  };

  const getFormattedDate = (date: string) => {
    return Dayjs(date).format("D MMMM YYYY").toLocaleLowerCase();
  };

  const getCollegeTitle = (collegeId: string) => {
    return collegeId !== "0" && item.collegeObject && item.collegeObject.title;
  };

  const getPlace = () => {
    let title = getCollegeTitle(item.college);
    if (!title) {
      title = item.place !== "" ? item.place : getStringPlaceHolder();
    }
    return title;
  };

  // Effects.

  useEffect(() => {
    setImages();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    // setImages();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [item.collegeObject]);

  return (
    // @ts-ignore
    <Document>
      {/*
 // @ts-ignore */}
      <Page size="A4" style={(baseStyles.page, styles.page)} wrap={false}>
        <View style={styles.decor}>
          <View style={[baseStyles.section, styles.logoWrapper]}>
            <ReactPdfImage
              src="/images/sprakombud_red.jpg"
              style={styles.logo}
            />
          </View>
          <View style={baseStyles.section}>
            <Text style={styles.title}>
              {I18n.get.languageRepresentativeDiploma.template.title}
            </Text>
          </View>
          <View style={baseStyles.section}>
            <Text style={styles.subtitle}>
              {I18n.get.languageRepresentativeDiploma.template.subtitle}
            </Text>
          </View>
          <View style={baseStyles.section}>
            <Text style={styles.person}>
              {item &&
                (item.firstname || item.lastname) &&
                getContactName(item)}
            </Text>
            <Text style={styles.personalNumber}>
              {item && item.personal_number}
            </Text>
            {item.course_moment && (
              <View
                style={[
                  baseStyles.section,
                  // styles.textWrapper,
                  styles.topBorder,
                ]}
              >
                <Text style={styles.centeredText}>
                  har fullgjort utbildningen under perioden
                </Text>
                <Text style={[styles.centeredText, styles.topMargin]}>
                  {getFormattedDate(item.course_moment.start_date)} -{" "}
                  {getFormattedDate(item.course_moment.end_date)}
                </Text>
              </View>
            )}
          </View>
          <View style={[baseStyles.section, styles.topBorder]}>
            <Text style={styles.text}>
              Utbildningen omfattar 4 heldagar samt tid för mellanliggande
              hemuppgifter och övningar. Utbildningen har genomförts enligt ett
              Blended Learning-koncept. Utbildningens mål är att ge deltagarna
              kunskap om språk, språkanvändning och språkutveckling samt
              interkulturell kommunikation i omsorgsarbetet. Utbildningen ger
              också verktyg och metoder som främjar språkutveckling på
              arbetsplatsen.
            </Text>
          </View>
          <View style={[baseStyles.section, styles.textContentPart]}>
            <Text style={styles.text}>Innehåll i utbildningen</Text>
            <View style={[styles.text, baseStyles.listItem]}>
              <Text style={baseStyles.listItemDot}>&bull;</Text>
              <Text>
                Andraspråksutveckling, andraspråksrelaterade hinder, stöttning
                av andraspråkstalare
              </Text>
            </View>
            <View style={[styles.text, baseStyles.listItem]}>
              <Text style={baseStyles.listItemDot}>&bull;</Text>
              <Text>Arbetsplatslärande</Text>
            </View>
            <View style={[styles.text, baseStyles.listItem]}>
              <Text style={baseStyles.listItemDot}>&bull;</Text>
              <Text>
                Studieovana, kort utbildningsbakgrund och läs- och
                skrivsvårigheter
              </Text>
            </View>
            <View style={[styles.text, baseStyles.listItem]}>
              <Text style={baseStyles.listItemDot}>&bull;</Text>
              <Text>
                Reflektionens betydelse för lärande och språkutveckling
              </Text>
            </View>
            <View style={[styles.text, baseStyles.listItem]}>
              <Text style={baseStyles.listItemDot}>&bull;</Text>
              <Text>Språkstimulerande övningar</Text>
            </View>
            <View style={[styles.text, baseStyles.listItem]}>
              <Text style={baseStyles.listItemDot}>&bull;</Text>
              <Text>Interkulturell kommunikation</Text>
            </View>
            <View style={[styles.text, baseStyles.listItem]}>
              <Text style={baseStyles.listItemDot}>&bull;</Text>
              <Text>Att hantera språkligt känsliga situationer</Text>
            </View>
          </View>
          <View style={baseStyles.grow}></View>
          {item && (
            <View style={baseStyles.section}>
              <Text style={[styles.text, styles.textCollege]}>
                {getPlace()}, {getDate()}
              </Text>
            </View>
          )}
          <View style={[baseStyles.section, styles.footer]}>
            {/* <View style={styles.signatures}>
              <View style={styles.signature}>
                <Text style={styles.signatureTitle}>
                  {I18n.get.languageRepresentativeDiploma.template.signature}
                </Text>
              </View>
            </View> */}

            <View style={styles.signatures}>
              {item && item.educator1 && (
                <View style={styles.signature}>
                  <Text style={styles.signaturePerson}>
                    {getContactName(item.educator1)}
                  </Text>
                  <Text style={styles.signatureTitle}>
                    {I18n.get.languageRepresentativeDiploma.template.educator}
                  </Text>
                </View>
              )}
              {item && item.educator2 && (
                <View style={styles.signature}>
                  <Text style={styles.signaturePerson}>
                    {getContactName(item.educator2)}
                  </Text>
                  <Text style={styles.signatureTitle}>
                    {I18n.get.languageRepresentativeDiploma.template.educator}
                  </Text>
                </View>
              )}
            </View>
          </View>
          <View style={styles.footerLogoWrapper}>
            {logotype && (
              <ReactPdfImage src={logotype} style={styles.footerLogo} />
            )}
          </View>
          {item && item.uid && item.uid.code && (
            <Text style={[baseStyles.uid, styles.uid]}>{item.uid.code}</Text>
          )}
        </View>
      </Page>
    </Document>
  );
};
export default LanguageRepresentativeDiplomaTemplate;
